import {BaseContainerModel} from '../base-container.model';
import {bl_asv_consultation_gendoc_hdr_link_RowClass} from '../../dbschema';

export class AsvConsultationGenDocHdrLinkModel extends BaseContainerModel {
    bl_asv_consultation_gendoc_hdr_link: bl_asv_consultation_gendoc_hdr_link_RowClass = new bl_asv_consultation_gendoc_hdr_link_RowClass();
}